import { useTranslation as useI18nTranslation } from 'react-i18next';
import { SUPPORTED_BOOKING_LANGUAGES, changeLanguage as changeLanguageSafe } from './config';

export function useTranslation() {
  const { t, i18n } = useI18nTranslation();
  
  return {
    t, // Функция перевода: t('booking.selectServices')
    language: i18n.language, // Текущий язык: 'ru' | 'en'
    changeLanguage: changeLanguageSafe, // Переключить: changeLanguage('en')
    languages: SUPPORTED_BOOKING_LANGUAGES,
  };
}
